import {
    IonPage, IonContent, IonInput, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import Script from "react-load-script";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";
import {FindPwdUnBindQuery, SendSmsCodeSlider, UnBindMacOperator} from "./Service";


class RemoveBind extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currpage: 1,
            isShowTip: false,
            showTipMsg: null,
            account: '',
            password: '',
            phone: '',
            code: '',
            djs: 60,
            doType: 1,
            smsType: 4,
            getCodeMsg: "获取验证码",
            isSuccessful: false,
            token: null,
        }
    }

    regCode = new RegExp(/^[0-9]{6}$/)

    handleScriptError = () => {
        this.setShowTipModal('组件加载失败')
    }
    handleScriptLoad = () => {
        this.setState({
            scriptLoaded: true,
        });
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    /**
     * 解除本机绑定
     * @param par
     */
    pageNext = (par) => {
        console.log(this.state.account)
        if (this.state.account == '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入用户名'
            })
            return false;
        }

        if (this.state.password.length < 6) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入密码'
            })
            return false;
        }

        // 1、输入用户名点击下一步滑块验证显示，成功后调用接口 用户名获取账号信息
        if (par == 1) {
            this.setState({
                doType: 1,
            })
            this.showView('getUserInfo');
        }
        // 2、选择操作途径, 显示手机号
        else if (par == 2) {
            this.setState({
                currpage: 3
            })
        }
        // 3、填写验证码，调用解除本机绑定接口
        else if (par == 3) {
            if (!this.regCode.test(this.state.code)) {

                this.setState({
                    isShowTip: true,
                    showTipMsg: '请输入正确的验证码'
                })

                return false;
            }

            let param = {
                protectType: 2,
                accounts: this.state.account,
                pwd: this.state.password,
                smsCode: this.state.code,
            }

            UnBindMacOperator(param).then(ret => {
                console.log(param);
                if (ret.code === '10000') {
                    console.log(ret.data);
                    this.setState({
                        currpage: 4,
                        isSuccessful: true,
                        showTipMsg: '解除绑定本机成功！'
                    })
                } else {
                    this.setState({
                        currpage: 4,
                        showTipMsg: '解除绑定本机失败(' + ret.msg + ')'
                    })
                }
            }).catch(err => {
                console.log(err);
                this.setState({
                    currpage: 4,
                    showTipMsg: '解除绑定本机失败(' + err + ')'
                })
            });
        }
    }

    showView = (par) => {
        const {getCodeMsg, smsType, account, password, doType, par1, par2} = this.state;
        if ("获取验证码" !== getCodeMsg) {
            return;
        }

        const _that = this;

        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {

            if (res.ret === 0) {

                const urlParms = {
                    'accounts': account,
                    'qType': doType,
                    'pwd': password,
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                }

                if (doType == 2) {
                    urlParms.ticketId = par1;
                    urlParms.tockenId = par2
                }

                if (par == 'getUserInfo') {
                    console.log(urlParms);
                    FindPwdUnBindQuery(urlParms).then(ret => {
                        if (ret.code === '10000') {
                            console.log(ret.data);
                            _that.setState({
                                currpage: 2,
                                phone: ret.data.phone,
                            })
                        } else {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                        captcha1.destroy();
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });

                } else {
                    urlParms.stype = smsType;
                    //console.log(urlParms);
                    SendSmsCodeSlider(urlParms).then(ret => {
                        captcha1.destroy();
                        if (ret.code === '10000') {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: '验证码已发送，请注意查收'
                            })
                            let djs = 60;
                            let aa = '';
                            let timeout = setInterval(function () {
                                djs--;
                                aa = (djs === 0) ? '获取短信验证码' : (djs + 's');
                                if (djs === 0 || djs < 0) {
                                    clearInterval(timeout);
                                }
                                _that.setState({djs: djs, getCodeMsg: aa})
                            }, 999)
                        } else {

                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});
        captcha1.show(); // 显示验证码
    }


    render() {

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className="phone_top pr mb56">
                            <div className="top_title">解绑本机</div>
                        </div>

                        <Script
                            url={captchaUrl()}
                            onError={this.handleScriptError}
                            onLoad={this.handleScriptLoad}
                        />
                        {/*<!------------解除绑定本机01----------------->*/}
                        {this.state.currpage == 1 &&
                            <div className="cont_kf">
                                <div className="phone_input_box pr">
                                    <div className="identity clearfix">
                                        <span className="w168">用户名</span>
                                        <IonInput type="text" className="input-tex4"
                                                  value={this.state.account}
                                                  onIonChange={e => this.setState({account: e.detail.value})}
                                                  placeholder="输入用户名"/>
                                    </div>
                                    <div className="identity clearfix">
                                        <span className="w168">密码</span>
                                        <IonInput type="password" className="input-tex4"
                                                  value={this.state.password}
                                                  onIonChange={e => this.setState({password: e.detail.value})}
                                                  placeholder="输入密码"/>
                                    </div>
                                    <a onClick={() => this.pageNext(1)} className="btn_kf mt100">下一步</a>
                                </div>
                            </div>
                        }
                        {this.state.currpage === 2 &&
                            <div className="cont_kf">
                                <div className="cx_tex">
                                    <p>通过验证手机</p>
                                </div>
                                <a onClick={() => this.pageNext(2)} className="btn_kf mt100">下一步</a>
                            </div>
                        }
                        {/*<!------------解除绑定本机03----------------->*/}
                        {this.state.currpage === 3 &&
                            <div className="cont_kf">
                                <div className="Input_box pr">
                                    <p className="pl25">您已经绑定了手机号码:{this.state.phone}</p>
                                    <div className="identity clearfix">
                                        <span className="w168">验证码</span>
                                        <IonInput type="text" className="input-tex2"
                                                  value={this.state.code} placeholder="请输入短信验证码"
                                                  maxlength={6} minlength={4}
                                                  onIonChange={e => this.setState({code: e.detail.value})}
                                        />
                                        <input type="button" onClick={() => this.showView('sendsms')}
                                               className="input-button-kefu" id="btn_submit"
                                               value={this.state.getCodeMsg}/>
                                    </div>
                                    <a onClick={() => this.pageNext(3)} className="btn_kf mt100">下一步</a>
                                </div>

                            </div>
                        }
                        {/*<!------------解除绑定本机04----------------->*/}
                        {this.state.currpage === 4 &&
                            <div className="cont_kf">
                                <div className="cx_tex">
                                    <p className={this.state.isSuccessful ? "textorange" : ""}>{this.state.showTipMsg}</p>
                                </div>
                                <a onClick={() => this.setState({currpage: 3})} className="btn_kf mt100">确定</a>
                            </div>
                        }
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(RemoveBind);
